__turbopack_context__.v({
  "className": "inconsolata_5ae5591-module__aMk7PG__className",
  "variable": "inconsolata_5ae5591-module__aMk7PG__variable",
});
